import {Dialog, DialogContent, DialogTitle, FormControl, Input, InputLabel, InputAdornment, IconButton} from '@material-ui/core';
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Button from "@components/common/button/Button";
import * as React from 'react';

import TranslateNew from '@translate/TranslateNew';
const tn :TranslateNew = TranslateNew.getInstance();

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value:string) => void;
}

interface IState {
  showPassword: boolean;
  newPassword:string;
}

class UpdatePasswordDialog extends React.Component<IProps, IState> {
  public static defaultProps = {
    isOpen: false
  };

  constructor(props:any) {
    super(props);

    this.state = {
      showPassword: false,
      newPassword:""
    };
  }

  public render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
      >
          <DialogTitle>
            {tn.lang.changePassword}
          </DialogTitle>
          <DialogContent>
            <FormControl margin="normal" required={true} fullWidth={true}>
              <InputLabel htmlFor="newPassword">{tn.lang.newPassword}</InputLabel>
              <Input
              style={{outline: "solid"}}
                id="newPassword"
                name="newPassword"
                type={this.state.showPassword ? "text" : "password"}
                onChange={(e) => this.setState({newPassword:e.target.value})}
                value={this.state.newPassword}
                inputProps={{ maxLength: 25 }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </DialogContent>
          <div style={{display: "flex", flexDirection: "column", margin: "8px 24px", padding: "8px 24px", gap: "10px"}}>
          <Button onClick={() => this.props.onSubmit(this.state.newPassword)} 
              disabled={this.state.newPassword.length< 6} variant='contained' color='primary' >
              {this.state.newPassword.length> 5?tn.lang.update:tn.lang.validationNewPasswordMin(6)}
            </Button>
            <Button onClick={this.props.onClose}>{tn.lang.cancel}</Button>
           
          </div>
      </Dialog>
    );
  }
}

export default UpdatePasswordDialog;



// WEBPACK FOOTER //
// ./src/components/settings/update-password.component.tsx